import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { AdminProductEdit } from "./admin/features";
import { OperatorProductEdit } from "./operator/features";
import { ProviderProductEdit } from "./provider/features";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const ProductEdit = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (role === admin) {
      return <AdminProductEdit />;
    }
    if (role === operator) {
      return <OperatorProductEdit />;
    }
    if (role === provider) {
      return <ProviderProductEdit />;
    }
    return null;
  };
  if (isLoading) {
    return <SkeletonAnnotated />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const ProductEditComponent = getComponent(currentUserRole);
  return ProductEditComponent;
};

export default ProductEdit;
